import * as React from "react";
import { Button } from "@components/ui/button";
import { cn } from "@lib/utils";

export function HelionButton({
  className,
  ...props
}: React.ComponentProps<typeof Button>) {
  return (
    <Button
      className={cn(
        "bg-[var(--button-bg)] text-[var(--button-text)] hover:bg-[var(--button-bg-hover)] active:bg-[var(--button-bg-hover)] border border-[var(--border-color)]",
        className
      )}
      {...props}
    />
  );
}